<template>
<div class="editCateSortDialog">
    <el-dialog @close='cancel' title="调整分类顺序" :visible.sync="dialogVisible" width="600px">
        <div class="goodsListDialog add_goods_box">
            <div class="right_main_box">
                <div class="add_goods_tabs_box">
                    <el-table :data="tableData" style="width: 100%" :show-header="false" ref="multipleTable">
                        <el-table-column type="index" width="50"></el-table-column>
                        <el-table-column prop="name" label="分类名称"></el-table-column>
                        <el-table-column label="操作" label-class-name="tr">
                            <template slot-scope="scope">
                                <div class="tr">
                                    <span class="separator-btn upordown">
                                        <div class="icon_bb_arrow" :class="[scope.$index==0?'prohibit':'']">
                                            <i @click.stop="handleUp(scope.row, scope.$index)" class="icon icon_bb_arrow_up"></i>
                                        </div>
                                        <div class="icon_bb_arrow" :class="[scope.$index==(tableData.length-1)?'prohibit':'']">
                                            <i @click.stop="handleDown(scope.row, scope.$index)" class="icon icon_bb_arrow_down"></i>
                                        </div>
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer"  style="margin-top: 20px;">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="sureEdit()">确 定</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getEventProductCateInfo, uploadEventProductCateIndex} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'editCateSortDialog',
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            param: {
                eventid: ''
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(obj) {
            this.param.eventid = obj.eventid
            this.dialogVisible = true
            this._getList()
        },
        handleUp(obj, index) {
            if (index == 0) return false
            this.tableData.splice(index, 1)
            this.tableData.splice(index - 1, 0, obj)
        },
        handleDown(obj, index) {
            if (index == this.tableData.length - 1) return false
            this.tableData.splice(index, 1)
            this.tableData.splice(index + 1, 0, obj)
        },
        sureEdit() {
            let list = []
            this.tableData.forEach((obj,index) => {
                list.push({
                    cateindex: index + 1,
                    code: obj.code
                })
            })
            let param = {
                eventid: this.param.eventid,
                list: list
            }
            this.setLoading(true)
            uploadEventProductCateIndex({
                data: param,
                success: data => {
                    this.setLoading(false)
                    this.cancel()
                    this.$emit('getList')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        cancel() {
            this.dialogVisible = false
        },
        _getList() {
            this.setLoading(true)
            getEventProductCateInfo({
                data: Object.assign({}, this.param),
                success: data => {
                    this.tableData = data.data.categoryinfo
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.editCateSortDialog {
    .el-table__body-wrapper{
        height: 500px;
        overflow-y: auto;
        .el-table__body{
            width: 100% !important;
            table-layout: auto;
        }
    }
    .upordown{
        justify-content: flex-end !important;
    }
}
</style>
